import * as React from "react";

function SvgCheckmark(props) {
  return <svg width={12} height={10} viewBox="0 0 12 10" fill="currentColor" {...props}><path d="M10.3334 0L9.54751 0.839504L4.07149 6.69071L2.42849 5.03587L1.619 4.22054L0 5.85121L0.809498 6.66654L3.28561 9.1605L4.11911 10L4.92861 9.13671L11.2141 2.42221L12 1.5827L10.3334 0Z" fill="currentColor" /></svg>;
}

export default "//cdn.scentbird.com/assets/frontbird-site/images/checkmark_b6274b.svg";
export { SvgCheckmark as ReactComponent };